import { formatAmount, toKobo } from './formatAmount'

/* eslint-disable import/prefer-default-export */
export const transformMandateRule = mandateRule => {
  const transformedMandateRule = mandateRule.split('|').map(item => {
    const [rule, isLimited, amount] = item.split(':')

    return {
      rule,
      isLimited: isLimited === 'True',
      amount: formatAmount(amount),
    }
  })
  return transformedMandateRule
}

export const transformMandateRuleConfig = mandateRule => {
  const transformedMandateRuleConfig = mandateRule.map(item => {
    const splitRule = item.rule.replace(/[()]/g, '').split('+')
    const categoryConfig = []

    splitRule.forEach(items => {
      const [category, authorizableNumber] = items.split('*')
      categoryConfig.push(
        {
          category: category.trim(),
          authorizableNumber: Number(authorizableNumber),
        },
      )
    })
    let isLimited
    // if (item.limit === 'True') {
    if (item.isLimited === true) {
      isLimited = true
    } else {
      isLimited = false
    }
    return {
      categoryConfig,
      isLimited,
      amount: toKobo(item.amount),
    }
  })
  return transformedMandateRuleConfig
}

export const transformBoolean = value => {
  switch (value) {
    case 'True':
      return 'Yes'
    case 'False':
      return 'No'
    case 'Conditional':
      return 'Conditional'
    case true:
      return 'Yes'
    default: return 'No'
  }
}
